import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizationService } from '../components/authorization/authorization.service';
@Injectable({ providedIn: 'root' })

export class AuthGuardService  {
  cookieToken = 'UNKNOWN';
    currentCountry: string;
    constructor(private _router: Router, private authService: AuthorizationService) {
    }
    isAuth = '';
    isAdminAuth='';

    canActivate(
      route: ActivatedRouteSnapshot,
    ): Observable<boolean>|Promise<boolean>|boolean {

      this.isAuth = sessionStorage.getItem('auth');
      if(this.isAuth !== null && this.isAuth === 'yes') {
        return true;
      } else {
        this._router.navigate(['/home']);
        return false;
      }
    }
}

@Injectable({ providedIn: 'root' })

export class AdminAuthGuardService  {
  cookieToken = 'UNKNOWN';
    currentCountry: string;
    constructor(private _router: Router, private authService: AuthorizationService) {
    }
    isAdminAuth='';

    canActivate(
      route: ActivatedRouteSnapshot,
    ): Observable<boolean>|Promise<boolean>|boolean {

      this.isAdminAuth = sessionStorage.getItem('adminauth');
      if(this.isAdminAuth !== null && this.isAdminAuth === 'yes') {
        return true;
      } else {
        this._router.navigate(['/home/acm']);
        return false;
      }
    }
}
